module.exports = __webpack_public_path__ + "assets/img/btn-detail-21740778.png";